"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _dateFns = require("date-fns");
var _core = require("@material-ui/core");
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _dates = require("../_utils/dates");
var _FilteredListUtils = require("./FilteredListUtils");
var _Filters = _interopRequireDefault(require("./Filters"));
var _SelectedFacetChips = _interopRequireDefault(require("./SelectedFacetChips"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    itemWrapper: {
      margin: '0',
      padding: '0',
      listStyleType: 'none',
      '& > li': (0, _defineProperty2.default)({
        margin: '0',
        padding: theme.spacing(6, 0),
        borderBottom: "2px solid ".concat(theme.palette.grey['A200'])
      }, theme.breakpoints.up('md'), {
        padding: theme.spacing(2.5, 0, 0, 0)
      })
    },
    root: (0, _defineProperty2.default)({
      display: 'flex',
      flexDirection: 'column',
      margin: 'auto',
      outline: 'none',
      background: theme.palette.background.default,
      width: '100%',
      height: '100%',
      padding: theme.spacing(4, 0, 0, 4)
    }, theme.breakpoints.up('md'), {
      borderRadius: '6px',
      marginLeft: 'auto',
      marginRight: 'auto',
      padding: theme.spacing(4, 4, 0, 4)
    }),
    desktopFilters: (0, _defineProperty2.default)({
      display: 'none'
    }, theme.breakpoints.up('md'), {
      display: 'flex',
      paddingLeft: theme.spacing(0),
      paddingTop: theme.spacing(3)
    }),
    filterModal: {
      maxWidth: '100vw'
    },
    emptyWrapper: {
      padding: theme.spacing(6, 0)
    },
    emptyHeading: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightBold,
      textTransform: 'uppercase'
    },
    emptySubheading: {
      fontSize: theme.typography.pxToRem(16)
    },
    head: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      backgroundColor: 'white',
      zIndex: 5,
      width: '100%',
      paddingRight: theme.spacing(4)
    },
    titleWrapper: (0, _defineProperty2.default)({
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightBold,
      letterSpacing: theme.typography.pxToRem(1),
      paddingTop: theme.spacing(1),
      width: 'calc(100% - 16px)'
    }, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(24)
    }),
    modalDoneButton: {
      margin: theme.spacing(4, 0),
      width: '100%',
      height: '40px'
    },
    modalDoneButtonWrap: {
      backgroundColor: 'white',
      marginRight: theme.spacing(4)
    },
    closeIcon: {
      fontSize: theme.typography.pxToRem(30)
    },
    mobileFilterWrapper: (0, _defineProperty2.default)({
      overflowY: 'auto'
    }, theme.breakpoints.up('md'), {
      overflowY: 'hidden'
    })
  };
});
var getSelectedFacets = function getSelectedFacets(facetState, checkboxFacets) {
  var selectedFacets = [];
  var checkbox = facetState.checkbox;
  if (checkbox) {
    var _loop = function _loop(checkboxGroup) {
      var _checkboxFacets$find;
      var facetLabel = (_checkboxFacets$find = checkboxFacets.find(function (facet) {
        return facet.itemKey === checkboxGroup;
      })) === null || _checkboxFacets$find === void 0 ? void 0 : _checkboxFacets$find.label;
      for (var checkboxKey in checkbox[checkboxGroup]) {
        if (checkbox[checkboxGroup][checkboxKey]) {
          selectedFacets.push({
            label: facetLabel,
            value: checkboxKey,
            itemKey: checkboxGroup
          });
        }
      }
    };
    for (var checkboxGroup in checkbox) {
      _loop(checkboxGroup);
    }
  }
  return selectedFacets;
};
var FilteredList = function FilteredList(props) {
  var listItems = props.listItems,
    ItemListComponent = props.ItemListComponent,
    itemListComponentProps = props.itemListComponentProps,
    dateRangeFacet = props.dateRangeFacet,
    checkboxFacets = props.checkboxFacets,
    datePickerProps = props.datePickerProps,
    dateFormat = props.dateFormat,
    sort = props.sort,
    _props$itemListRender = props.itemListRenderEmpty,
    itemListRenderEmpty = _props$itemListRender === void 0 ? false : _props$itemListRender,
    anchorId = props.anchorId,
    translations = props.translations;
  var emptyHeading = translations.noSearchResults || 'No Search Results';
  var emptySubheading = translations.changeFilterCriteria || 'Try changing or broadening your filter criteria.';
  var classes = useStyles();
  var _React$useReducer = _react.default.useReducer(_FilteredListUtils.facetStateReducer, (0, _FilteredListUtils.facetInit)(listItems, dateRangeFacet, checkboxFacets)),
    _React$useReducer2 = (0, _slicedToArray2.default)(_React$useReducer, 2),
    facetState = _React$useReducer2[0],
    facetDispatch = _React$useReducer2[1];
  var _useState = (0, _react.useState)(false),
    isFilterAndSortModalOpen = _useState[0],
    setIsFilterAndSortModalOpen = _useState[1];
  var selectedFacets = getSelectedFacets(facetState, checkboxFacets);
  var toggleFilterAndSortModal = function toggleFilterAndSortModal() {
    return setIsFilterAndSortModalOpen(!isFilterAndSortModalOpen);
  };
  var sortedItems = _react.default.useMemo(function () {
    if (sort && sort.key && sort.direction) {
      return listItems === null || listItems === void 0 ? void 0 : listItems.sort(function (a, b) {
        var sortResult = 0;
        var compareItems = function compareItems(first, second, compareFunction) {
          if (sort.objectArrayKey) {
            var aFirst = first[sort.objectArrayKey] && first[sort.objectArrayKey].sort(function (x, y) {
              var xyResult = compareFunction(x[sort.key], y[sort.key]);
              return sort.direction === 'ascending' ? xyResult : -xyResult;
            })[0];
            var bFirst = second[sort.objectArrayKey] && second[sort.objectArrayKey].sort(function (x, y) {
              var xyResult = compareFunction(x[sort.key], y[sort.key]);
              return sort.direction === 'ascending' ? xyResult : -xyResult;
            })[0];
            if (!aFirst && !bFirst) {
              return 0;
            } else if (!aFirst) {
              return -1;
            } else if (!bFirst) {
              return 1;
            } else {
              return compareFunction(aFirst[sort.key], bFirst[sort.key]);
            }
          } else return compareFunction(first[sort.key], second[sort.key]);
        };
        switch (sort.type) {
          default:
          case 'string':
            sortResult = compareItems(a, b, _FilteredListUtils.stringCompare);
            break;
          case 'date':
            sortResult = compareItems(a, b, _FilteredListUtils.dateCompare);
            break;
        }
        return sort.direction === 'ascending' ? sortResult : -sortResult;
      });
    } else {
      return listItems;
    }
  }, [listItems, sort]);

  // save only active facets
  var activeFacets = {};
  var selectedFacetsCounter = 0;
  var checkboxEntries = Object.entries(facetState.checkbox);
  for (var _i = 0, _checkboxEntries = checkboxEntries; _i < _checkboxEntries.length; _i++) {
    var _checkboxEntries$_i = (0, _slicedToArray2.default)(_checkboxEntries[_i], 2),
      key = _checkboxEntries$_i[0],
      facetObjects = _checkboxEntries$_i[1];
    activeFacets[key] = [];
    for (var _i2 = 0, _Object$entries = Object.entries(facetObjects); _i2 < _Object$entries.length; _i2++) {
      var _Object$entries$_i = (0, _slicedToArray2.default)(_Object$entries[_i2], 2),
        key1 = _Object$entries$_i[0],
        value1 = _Object$entries$_i[1];
      if (value1) {
        selectedFacetsCounter = selectedFacetsCounter + 1;
        activeFacets[key].push(key1);
      }
    }
  }
  var filteredItems = sortedItems === null || sortedItems === void 0 ? void 0 : sortedItems.filter(function (item) {
    var dateFlag = true;
    var checkboxFlag = true;
    if (dateRangeFacet) {
      var facetStartDate = facetState.dateRange.start || (dateRangeFacet.start.default ? new Date(dateRangeFacet.start.default) : null);
      var facetEndDate = facetState.dateRange.end || (dateRangeFacet.end.default ? new Date(dateRangeFacet.end.default) : null);
      if (dateRangeFacet.objectArrayKey) {
        dateFlag = item[dateRangeFacet.objectArrayKey] && item[dateRangeFacet.objectArrayKey].some(function (item) {
          var itemDate = (0, _dates.removeTimezone)(item[dateRangeFacet.start.itemKey]);
          var parsedFacetStartDate = facetStartDate ? new Date(facetStartDate) : null;
          parsedFacetStartDate && parsedFacetStartDate.setHours(0, 0, 0, 0);
          var parsedFacetEndDate = facetEndDate ? new Date(facetEndDate) : null;
          parsedFacetEndDate && parsedFacetEndDate.setHours(23, 59, 59, 999);
          if (facetStartDate && parsedFacetStartDate && (0, _dateFns.isBefore)(itemDate, parsedFacetStartDate) || facetEndDate && parsedFacetEndDate && (0, _dateFns.isAfter)(itemDate, parsedFacetEndDate)) return false;else return true;
        });
      } else {
        var itemStartDate = (0, _dates.removeTimezone)(item[dateRangeFacet.start.itemKey]);
        var itemEndDate = (0, _dates.removeTimezone)(item[dateRangeFacet.end.itemKey]);
        if (facetStartDate && (0, _dateFns.isBefore)(itemStartDate, facetStartDate) && (0, _dateFns.isBefore)(itemEndDate, facetStartDate) || facetEndDate && (0, _dateFns.isAfter)(itemStartDate, facetEndDate) && (0, _dateFns.isAfter)(itemEndDate, facetEndDate)) dateFlag = false;
      }
    }
    if (selectedFacetsCounter && checkboxFacets && checkboxFacets.length > 0) {
      checkboxFlag = checkboxFacets.every(function (facet) {
        if (activeFacets[facet.itemKey].length > 0) {
          switch (facet.itemType) {
            case 'string':
              return facetState.checkbox[facet.itemKey][item[facet.itemKey]];
            case 'array':
              var foundFacet = item[facet.itemKey].filter(function (element) {
                return activeFacets[facet.itemKey].includes(element);
              });
              return !(foundFacet.length === 0);
            default:
              return false;
          }
        }
        return true;
      });
    }
    return dateFlag && checkboxFlag;
  });
  var timer;
  var handleDateRangeFacetChange = function handleDateRangeFacetChange(id) {
    return function (date) {
      clearInterval(timer);
      timer = setInterval(function () {
        if (date && !isNaN(date.getTime())) {
          (0, _FilteredListUtils.setQueryParam)(_FilteredListUtils.FILTER_PARAMS.dateRange[id], date ? 'add' : 'remove', date ? (0, _dateFns.format)(date, 'yyyy-MM-dd').toString() : undefined);
          facetDispatch({
            type: 'daterange',
            key: id,
            date: date
          });
          clearInterval(timer);
        }
      }, 1000);
    };
  };
  var handleCheckboxFacetChange = function handleCheckboxFacetChange(itemKey, keyToUse, isChecked) {
    return function (event) {
      var itemValue = keyToUse ? keyToUse : event.target.value;
      var checked = typeof isChecked === 'boolean' ? isChecked : event.target.checked;
      (0, _FilteredListUtils.setQueryParam)(_FilteredListUtils.FILTER_PARAMS[itemKey], checked ? 'add' : 'remove', itemValue);
      facetDispatch({
        type: 'checkbox',
        facet: itemKey,
        key: itemValue,
        boolean: checked
      });
    };
  };
  var handleCheckboxFacetChangeAll = function handleCheckboxFacetChangeAll(itemKey) {
    return function (newValue) {
      (0, _FilteredListUtils.setQueryParam)(_FilteredListUtils.FILTER_PARAMS[itemKey], 'removeAll');
      facetDispatch({
        type: 'checkboxAll',
        facet: itemKey,
        boolean: newValue
      });
    };
  };
  var emptyResultDefault = __jsx("div", {
    className: classes.emptyWrapper
  }, __jsx("p", {
    className: classes.emptyHeading
  }, emptyHeading), __jsx("p", {
    className: classes.emptySubheading
  }, emptySubheading));
  var filterProps = {
    dateRangeFacet: dateRangeFacet,
    dateFormat: dateFormat,
    datePickerProps: datePickerProps,
    facetState: facetState,
    checkboxFacets: checkboxFacets,
    uncheckallText: translations.uncheckAll,
    invalidDateMessage: translations.invalidDate,
    maxDateMessage: translations.invalidStartDate,
    minDateMessage: translations.invalidEndDate,
    handleDateRangeFacetChange: handleDateRangeFacetChange,
    handleCheckboxFacetChange: handleCheckboxFacetChange,
    handleCheckboxFacetChangeAll: handleCheckboxFacetChangeAll
  };
  var hasFilteredItems = filteredItems && (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) > 0;
  return __jsx("div", {
    id: anchorId,
    className: "aem-ms-cmp"
  }, __jsx(_core.Grid, {
    container: true
  }, __jsx(_core.Grid, {
    item: true,
    xs: 12,
    md: 3
  }, __jsx(_core.Modal, {
    className: classes.filterModal,
    open: isFilterAndSortModalOpen
  }, __jsx("div", {
    className: classes.root
  }, __jsx("div", {
    className: classes.head
  }, __jsx(_core.Typography, {
    component: "div",
    className: classes.titleWrapper
  }, translations.filters), __jsx(_core.ButtonBase, {
    onClick: toggleFilterAndSortModal
  }, __jsx(_Close.default, {
    className: classes.closeIcon
  }))), __jsx("div", {
    className: classes.mobileFilterWrapper
  }, __jsx("div", null, __jsx(_SelectedFacetChips.default, {
    appliedFiltersLabel: translations.appliedFilters,
    selectAllFiltersLabel: translations.selectAllFilters,
    deselectAllFiltersLabel: translations.deselectAllFilters,
    checkboxFacets: checkboxFacets,
    selectedFacets: selectedFacets,
    handleCheckboxFacetChange: handleCheckboxFacetChange,
    handleCheckboxFacetChangeAll: handleCheckboxFacetChangeAll
  })), __jsx(_Filters.default, filterProps)), __jsx("div", {
    className: classes.modalDoneButtonWrap
  }, __jsx(_core.Button, {
    variant: "contained",
    color: "primary",
    className: classes.modalDoneButton,
    onClick: toggleFilterAndSortModal
  }, translations.done)))), __jsx("div", {
    className: (0, _clsx.default)(classes.root, classes.desktopFilters)
  }, __jsx(_Filters.default, filterProps))), __jsx(_core.Grid, {
    item: true,
    xs: 12,
    md: 9
  }, !hasFilteredItems && !itemListRenderEmpty ? emptyResultDefault : __jsx(ItemListComponent, (0, _extends2.default)({
    items: filteredItems,
    wrapperClass: classes.itemWrapper,
    emptyResultDefault: emptyResultDefault,
    selectedFacets: selectedFacets,
    facetState: facetState,
    toggleFilterAndSortModal: toggleFilterAndSortModal
  }, itemListComponentProps)))));
};
var _default = FilteredList;
exports.default = _default;